import { com } from '@eidu/web'
import EqualityHashMap from '../util/EqualityHashMap'
import EntityWithLabelAndRelated from '../domain/entity/EntityWithLabelAndRelated'
import getEntitiesOfType from './api/entity/data/getEntitiesOfType'
import { getEntitiesFromResponseVariant } from '../domain/entity/getEntitiesFromResponses'
import fetchAllPages from './fetchAllPages'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityId = com.eidu.sharedlib.entity.EntityId
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import Entity = com.eidu.sharedlib.entity.Entity
import IndexedPaginatedResponseWithRelated = com.eidu.api.pagination.IndexedPaginatedResponseWithRelated

const fetchAllEntitiesOfType = async (
  typeId: EntityTypeId,
  pageSize: number,
  searchQuery: string | undefined,
  types: ReadonlyMap<EntityTypeId, EntityType>
): Promise<ReadonlyMap<EntityId, EntityWithLabelAndRelated>> => {
  const responses = await fetchAllPages(pageSize, (pageIndex) =>
    getEntitiesOfType({
      id: typeId,
      withRelatedEntities: true,
      pageIndex,
      pageSize,
      query: searchQuery,
    }).then((r) => r as IndexedPaginatedResponseWithRelated<Entity>)
  )
  const entries = responses.flatMap((response) => getEntitiesFromResponseVariant(response, types))
  return new EqualityHashMap(entries)
}

export default fetchAllEntitiesOfType
